import { Link, useLocation } from "react-router-dom";
import ImmersiveBackground from "@/components/ui/ImmersiveBackground";
import { useDocumentMeta } from "@/lib/useDocumentMeta";

export default function NotFoundPage() {
  const { pathname } = useLocation();
  useDocumentMeta({
    title: "Page Not Found",
    description: "This page couldn't be found on Nerd Multiverse.",
    path: pathname,
    noindex: true,
  });

  return (
    <div className="relative pt-40 pb-24 min-h-dvh text-center px-4">
      <ImmersiveBackground
        src="/images/hero/not-found-hero.webp"
        mobileSrc="/images/hero/not-found-mobile-v2.webp"
        focus="50% 20%"
      />
      <p className="font-display text-3xl text-white">
        This corner of the multiverse doesn&apos;t exist.
      </p>
      <p className="mt-3 text-[var(--nm-ink-muted)]">
        Your next find is probably somewhere else in the marketplace.
      </p>
      <Link
        to="/marketplace"
        className="mt-8 inline-block px-7 py-3.5 rounded-full bg-white text-[#05070d] text-sm font-medium tracking-wide hover:bg-[var(--nm-blue-bright)] hover:text-white transition-colors"
      >
        EXPLORE THE MARKETPLACE
      </Link>
    </div>
  );
}
